// Drives any [data-auto-scroll-carousel] wrapper: auto-scrolls its first
// child track at a constant speed, pausing on touch/drag/hover/focus and
// resuming (from wherever the user left it) shortly after they let go.
// The track is expected to contain the content duplicated 2x for a
// seamless loop; we wrap the scroll position at the halfway point.
(function () {
  function initCarousel(wrap) {
    if (wrap.dataset.autoScrollInit) return;
    wrap.dataset.autoScrollInit = 'true';

    var track = wrap.firstElementChild;
    if (!track) return;

    var durationSeconds = parseFloat(wrap.dataset.speed || '40');
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var setWidth = 0;
    function measure() {
      setWidth = track.scrollWidth / 2;
    }
    measure();
    window.addEventListener('resize', measure);

    if (prefersReduced || !setWidth) return;

    var paused = false;
    var resumeTimer = null;
    var lastTime = null;

    function pxPerSecond() {
      return setWidth / durationSeconds;
    }

    function step(timestamp) {
      if (lastTime == null) lastTime = timestamp;
      var dt = (timestamp - lastTime) / 1000;
      lastTime = timestamp;

      if (!paused) {
        wrap.scrollLeft += pxPerSecond() * dt;
        if (wrap.scrollLeft >= setWidth) {
          wrap.scrollLeft -= setWidth;
        }
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);

    function pause() {
      paused = true;
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function scheduleResume(delay) {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        // Normalize into the first copy so wrapping stays seamless even
        // if the user dragged into the duplicated second copy.
        wrap.scrollLeft = ((wrap.scrollLeft % setWidth) + setWidth) % setWidth;
        lastTime = null;
        paused = false;
      }, delay);
    }

    wrap.addEventListener('pointerdown', pause, { passive: true });
    wrap.addEventListener('touchstart', pause, { passive: true });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (evt) {
      wrap.addEventListener(evt, function () {
        scheduleResume(1200);
      }, { passive: true });
    });

    wrap.addEventListener('mouseenter', pause);
    wrap.addEventListener('mouseleave', function () {
      scheduleResume(300);
    });
    wrap.addEventListener('focusin', pause);
    wrap.addEventListener('focusout', function () {
      scheduleResume(300);
    });
  }

  function init() {
    document.querySelectorAll('[data-auto-scroll-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
